/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const ClientCloseIcon = ({ fill, style, ...rest }) => (
  <svg
    {...rest}
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 20.995 20.998"
    style={{ enableBackground: 'new 0 0 20.995 20.998', ...style }}
    xmlSpace="preserve"
  >
    <path
      id="Path_1537"
      fill={fill}
      d="M11.479,10.498l9.316-9.316c0.267-0.272,0.267-0.709,0-0.981
	c-0.272-0.267-0.709-0.267-0.981,0l-9.316,9.316L1.182,0.201c-0.272-0.267-0.709-0.267-0.981,0c-0.267,0.272-0.267,0.709,0,0.981
	l9.316,9.316l-9.316,9.316c-0.267,0.272-0.267,0.709,0,0.981c0.27,0.271,0.709,0.271,0.98,0.001c0,0,0.001-0.001,0.001-0.001
	l9.316-9.316l9.316,9.316c0.27,0.271,0.709,0.271,0.98,0.001c0,0,0.001-0.001,0.001-0.001c0.267-0.272,0.267-0.709,0-0.981
	L11.479,10.498z"
    />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);

ClientCloseIcon.propTypes = {
  fill: PropTypes.string,
  style: PropTypes.object,
  rest: PropTypes.object,
};

ClientCloseIcon.defaultProps = {
  fill: '#E14E52',
  style: {},
  rest: {},
};

export default ClientCloseIcon;



// WEBPACK FOOTER //
// ./src/assets/ClientCloseIcon.jsx